import { TranslateService } from '@ngx-translate/core';

import { epicDependencies } from '../../../../../store';
import { TranscriptCategories } from '../model/transcript-categories.model';
import { TranscriptData } from '../model/transcript-data.model';
import { TranslationKeyMap } from '../transcript-summary.i18n';

export function setDefaultTranscriptTitle(
    categories: TranscriptCategories[],
): void {
    const transcripts: TranscriptData[] = [];
    categories.forEach((e) => {
        e.subCategories.reduce((p, c) => {
            p.push(...c.transcripts);
            return p;
        }, transcripts);
    });

    const emptyTitles = transcripts.filter(
        (e) => e.title == null || e.title?.trim()?.length === 0,
    );
    if (emptyTitles.length > 0) {
        // TODO FIXME. this can be done better
        const service =
            epicDependencies.injector.get<TranslateService>(TranslateService);
        emptyTitles.forEach((e) => {
            e.title = `${
                service.instant(TranslationKeyMap._9996_TRANSCRIPTS) as string
            } ${e.transcriptId?.toString()}`;
        });
    }
}
